import type { MailboxInfo } from "owa-client-types";
import type { OwsRequestOptions } from "./OwsRequestOptions";
import type OwsMailboxRequestOptions from "./OwsMailboxRequestOptions";
import assert from "owa-assert/lib/assert";

export default function getOwsMailboxRequestOptions<K extends boolean | undefined = undefined>(mailboxInfo: MailboxInfo, owsRequestOptions?: OwsRequestOptions<K> | undefined | null): OwsMailboxRequestOptions<K> {
    assert(mailboxInfo, "MailboxInfo must not be null or undefined");
    return {
        ...owsRequestOptions,
        mailboxInfo,
    } as OwsMailboxRequestOptions<K>; // mailboxInfo is not optional
}
